interface FormatMoneyConfig {
    value: number;
    currency: string;
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
    signDisplay?: 'auto' | 'always' | 'never' | 'exceptZero' | 'negative';
}

export const formatMoney = ({
    value,
    currency,
    minimumFractionDigits = 0,
    maximumFractionDigits,
    signDisplay = 'auto',
}: FormatMoneyConfig) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
        minimumFractionDigits,
        maximumFractionDigits,
        signDisplay,
    }).format(value);
};
